import {MGiftVoucherPriceCategory} from '../../../master-files/m-gift-voucher-price-category/model/m-gift-voucher-price-category';
import {TGiftVoucherTransferItem} from './t-gift-voucher-transfer-item';

export class TGiftVoucherTransferRequest {
  indexNo: number;
  requestQty: number;
  mGiftVoucherPriceCategory: MGiftVoucherPriceCategory;
  tGiftVoucherTransferItemList: TGiftVoucherTransferItem [] = [];
  totalStockQty: number;
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-gift-voucher-transfer/model/t-gift-voucher-transfer-request.ts